<template>
    <div id="edit">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-bullhorn"></i> News</div>
        </div>
        <hr>
        <form>
            <div class="columns box is-multiline">
                <div class="column is-6">
                    <div class="field">
                        <bulma-input name="name" v-model="news.title" rules="required" placeholder='Title'/>
                    </div>
                </div>

                <div class="column is-6">
                    <div class="field">
                        <div class="select is-fullwidth">
                            <select v-model="news.type">
                                <option value="update">update</option>
                                <option value="coupon">coupon</option>
                                <option value="subscription">subscription</option>
                                <option value="alert">alert</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="column is-12">
                    <div class="field">
                        <textarea class="textarea" name="description" v-model="news.description" rules="" placeholder='Description'/>
                    </div>
                </div>

                <div class="column is-12">
                    <div class="field">
                        <editor :content="content" :lang="'html'" :height="'500px'" :theme="'monokai'" :sync="true"></editor>
                        <!--<textarea class="textarea html-editor" name="text" v-model="news.text" rules="" placeholder='Text'/>-->
                    </div>
                </div>
            </div>
            <div class="columns box is-multiline">
                <div class="column">
                    <div class="content" v-html="news.text">

                    </div>
                </div>
            </div>
            <div class="columns box is-multiline">
                <div class="column is-2">                    
                    <loading-button v-bind:loading="loading" color="is-info" @click="save()">Save</loading-button>                    
                </div>              
                <div class="column is-2 is-offset-8 is-pulled-right">                                           
                    <a href="javascript:history.go(-1)" class="button is-block">
                        Back
                    </a>                   
                </div>              
            </div>                      
        </form>
    </div>  
</template>

<script>
import NewsRepo from '../../repos/NewsRepo'
import _ from 'lodash'
import editor from 'vue2-ace'
import 'brace/mode/html'
import 'brace/theme/monokai'

export default {
  name: 'news-edit',
  components: {editor},
  data() {
        return {
            repo: new NewsRepo(this.$auth),
            loading: false,
            news: {},
            content: '',
        }
  },
  created(){
    this.getNews(this.$route.params.id);
  },
    mounted(){
        let self = this;
        this.$on('editor-update', (val) => {
            self.news.text = val;
        });
    },
  methods: {
    getNews(id){
        this.repo.show(id).then(response => {
            this.news = response.data.data;
            this.content = this.news.text;
        });
    },
    save(){            
        this.$validator.validateAll().then((result) => {
	    if (result) {
                let self = this;
                this.loading = true;                                
                
                this.repo.update(this.news.id, this.news).then(function (response) {
                    
                    self.loading = false;
                    self.$toast.success(response.data.message);
                    self.$router.push('/dashboard/news');
                }).catch(function(response){
                    self.loading = false;                    
                    return Promise.reject(response);
                });
            }
        });
    
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>
    .html-editor{
        min-height: 500px;
    }
</style>


// WEBPACK FOOTER //
// src/components/news/Edit.vue